module.exports = __webpack_public_path__ + "img/mensaje_imporante.fb632bc5.png";